import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'

import {
  loadLoginHistories,
  loadLoginHistoriesSuccess,
  loadLoginHistoriesFailure
} from './login-history.actions'

import { LoginHistoryService } from '../../services/login-history.service'

export const loadLoginHistories$ = createEffect(
  (actions$ = inject(Actions), loginHistoryService = inject(LoginHistoryService)) =>
    actions$.pipe(
      ofType(loadLoginHistories),
      switchMap(action =>
        loginHistoryService.getLoginHistories(action.params, action.page, action.limit).pipe(
          map(res =>
            loadLoginHistoriesSuccess({
              loginHistories: res.loginHistories ?? [],
              totalCount: res.totalCount ?? 0,
              totalRowCount: res.totalRowCount ?? res.totalCount ?? 0,
              successfulLoginCount: res.successfulLoginCount ?? 0,
              failedLoginCount: res.failedLoginCount ?? 0,
              loggedOutLoginCount: res.loggedOutLoginCount
            })
          ),
          catchError(error =>
            of(
              loadLoginHistoriesFailure({
                error: error?.error?.message ?? error?.message ?? 'Failed to load login history'
              })
            )
          )
        )
      )
    ),
  { functional: true }
)

export const loginHistoryEffects = {
  loadLoginHistories$
}
